export default class Anchor {
    static init(): void {
        const anchors = document.querySelectorAll('[data-base-anchor]');

        anchors.forEach((anchor) => {
            anchor.addEventListener('click', (e: Event) => {
                e.preventDefault();

                const targetId = (e.currentTarget as HTMLElement).getAttribute('data-base-anchor');

                // Close mobile menu if open
                this.closeMobileMenu();

                // Detect if mobile or desktop
                const isMobile = window.innerWidth < 992;

                // Find target element based on device
                const targetElement = isMobile
                    ? document.querySelector<HTMLElement>(`[data-anchor-mobile="${targetId}"]`)
                    : document.querySelector<HTMLElement>(`[data-anchor-desktop="${targetId}"]`);

                if (targetElement) {
                    const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

                    window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth',
                    });
                }
            });
        });
    }

    static closeMobileMenu(): void {
        const navbarMobileMenu = document.querySelector<HTMLElement>('.navbar-mobile-menu');
        const htmlBodyTag = document.querySelector<HTMLElement>('body');
        const menuSubmenuInit = document.querySelector<HTMLElement>('.navbar-mobile-submenu');

        if (navbarMobileMenu && navbarMobileMenu.classList.contains('is-active')) {
            navbarMobileMenu.classList.remove('is-animate');
            setTimeout(() => {
                if (htmlBodyTag) {
                    htmlBodyTag.classList.remove('overlay-is-active');
                }
                navbarMobileMenu.classList.remove('is-active');

                if (menuSubmenuInit) {
                    menuSubmenuInit.classList.remove('is-active');
                    menuSubmenuInit.classList.remove('is-animate');
                }
            }, 300);
        }
    }
}
